import {
  JobCatalogWorkingConditionsAttributeInput,
  NodePageDocument,
  UpdateJobCatalogNodeAttributeDocument,
  UpdateJobCatalogNodeAttributeMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import {
  formatUuidToNodeType,
  getChildNodeType,
  getNodeId,
} from 'modules/job_catalog/lib/nodesUtils'
import {
  WorkingConditions,
  workingConditionsToAttribute,
} from 'modules/job_catalog/lib/workingConditions'

const useUpdateJobCatalogAttribute = () => {
  const [mutate, { loading }] = useMutation(UpdateJobCatalogNodeAttributeDocument, {
    extractorFn: (data: UpdateJobCatalogNodeAttributeMutation) =>
      data.jobCatalogMutations.updateJobcatalogNodeAttribute,
  })

  const updateAttribute = (
    id: number,
    companyId: number,
    nodeUuid: string,
    attribute: { valueWorkingConditions?: JobCatalogWorkingConditionsAttributeInput },
    serializedAttribute?: string
  ) => {
    const nodeId = getNodeId(nodeUuid)
    const nodeType = formatUuidToNodeType(nodeUuid)
    const childType = getChildNodeType(nodeUuid)

    return mutate({
      variables: {
        id,
        companyId,
        nodeId,
        nodeType,
        ...attribute,
        valueJson: serializedAttribute,
      },
      refetchQueries: [
        {
          query: NodePageDocument,
          variables: {
            nodeUuid,
            childType,
          },
        },
      ],
    })
  }

  const updateSalary = (
    id: number,
    companyId: number,
    nodeUuid: string,
    serializedAttribute: string
  ) => {
    // TODO: Apply typing on a later PR
    return updateAttribute(id, companyId, nodeUuid, {}, serializedAttribute)
  }

  const updateWorkingConditions = (
    id: number,
    companyId: number,
    nodeUuid: string,
    workingConditions: WorkingConditions
  ) => {
    return updateAttribute(id, companyId, nodeUuid, workingConditionsToAttribute(workingConditions))
  }

  return { updateSalary, updateWorkingConditions, loading }
}

export default useUpdateJobCatalogAttribute
